import React, { useState } from "react";
import { Link } from "react-router-dom";
import perfume from "../../Images/Perfume.png";
import bodySpray from "../../Images/body-spray.png";
import airFreshner from "../../Images/air-freshner.png";
import privateLabel from "../../Images/Private-label.png";
import WhiteLabel from "../../Images/white-label.png";
import contract from "../../Images/contract.png";

const WhatWeDo = () => {
  const [visible, setVisible] = useState(false);
  return (
    <div
      className="dropdown-trigger"
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      <div className="nav-link">WHAT WE DO</div>
      <div className={`dropdown-menu mt-[18px] ${visible ? "flex" : ""}`}
        style={{ display: visible ? "flex" : "", flexDirection: "column" }}
      >
        <Link className="dropdown-item" to="/perfume-manufacture">
          <img alt="" src={perfume} />
          <span>PERFUMES</span>
        </Link>
        <hr className="dropdown-divider" />
        <Link className="dropdown-item" to="/body-spray-manufacture">
          <img alt="" src={bodySpray} />
          <span>BODY SPRAY</span>
        </Link>
        <hr className="dropdown-divider" />
        <Link className="dropdown-item" to="/air-freshner-manufacture">
          <img alt="" src={airFreshner} />
          <span>AIR FRESHNER</span>
        </Link>
        <hr className="dropdown-divider" />
        <Link className="dropdown-item" to="/private-label">
          <img alt="" src={privateLabel} />
          <span>PRIVAT LABEL</span>
        </Link>
        <hr className="dropdown-divider" />
        <Link className="dropdown-item" to="/white-label-manufacture">
          <img alt="" src={WhiteLabel} />
          <span>WHITE LABEL</span>
        </Link>
        <hr className="dropdown-divider" />
        <Link className="dropdown-item" to="/contract-manufacture">
          <img alt="" src={contract} />
          <span>CONTRACT MANUFACTURE</span>
        </Link>
      </div>
    </div>
  );
};

export default WhatWeDo;
